var map = {
	"./de.png": "a46d",
	"./en.png": "6e4c",
	"./es.png": "8177",
	"./fr.png": "d321",
	"./it.png": "7857",
	"./logo 2.png": "0d36",
	"./logo.png": "9d64",
	"./united-kingdom.png": "e242",
	"./united-states.png": "1f8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";